type FeatureFlag = "preventivo" | "account" | "admin" | "auth";

const featureDefaults: Record<FeatureFlag, boolean> = {
  preventivo: true,
  account: true,
  admin: true,
  auth: true,
};

function parseFlag(value: string | undefined, fallback: boolean): boolean {
  if (value === undefined) return fallback;
  return value === "true" || value === "1";
}

export function isFeatureEnabled(feature: FeatureFlag): boolean {
  switch (feature) {
    case "preventivo":
      return parseFlag(process.env.NEXT_PUBLIC_FEATURE_PREVENTIVO, featureDefaults.preventivo);
    case "account":
      return parseFlag(process.env.NEXT_PUBLIC_FEATURE_ACCOUNT, featureDefaults.account);
    case "admin":
      return parseFlag(process.env.NEXT_PUBLIC_FEATURE_ADMIN, featureDefaults.admin);
    case "auth":
      return parseFlag(process.env.NEXT_PUBLIC_FEATURE_AUTH, featureDefaults.auth);
    default:
      return false;
  }
}

import { NextResponse } from "next/server";

export function featureDisabledResponse(): NextResponse {
  return NextResponse.json(
    { error: "Funzionalità non disponibile" },
    { status: 404 }
  );
}

export type { FeatureFlag };